import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TDaiyoZyomuinUriageListGetReq,
  TDaiyoZyomuinUriageListGetRes,
  TDaiyoZyomuinUriagePutReq,
} from "./TDaiyoZyomuinUriage"

/**
 * 大陽乗務員売上に対するAPIリクエスト用サービス
 *
 * @export
 * @class DaiyoZyomuinUriageService
 * @extends {ConnectApi}
 */
export default class DaiyoZyomuinUriageService extends ConnectApi {
  /**
   * 一覧取得
   *
   * @param {TDaiyoZyomuinUriageListGetReq} params
   * @memberof DaiyoZyomuinUriageService
   */
  getList = async (params: TDaiyoZyomuinUriageListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TDaiyoZyomuinUriageListGetRes[]>> =
        await this.getInner(`billing/taiyozyomuinuriage/register`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 売上 更新
   *
   * @param {TDaiyoZyomuinUriagePutReq} data
   * @param {(param: TApiResponse<TSyaryoSyozokuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyaryoSyozokuListGetRes[]>>) => any} reject
   * @memberof DaiyoZyomuinUriageService
   */
  put = async (data: TDaiyoZyomuinUriagePutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/taiyozyomuinuriage/register`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 売上 更新(受注配車も売上更新)
   *
   * @param {TDaiyoZyomuinUriagePutReq} data
   * @param {(param: TApiResponse<TSyaryoSyozokuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyaryoSyozokuListGetRes[]>>) => any} reject
   * @memberof DaiyoZyomuinUriageService
   */
  putHaisya = async (data: TDaiyoZyomuinUriagePutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/taiyozyomuinuriage/register/haisya`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
